import { useState ,useEffect} from "react";

export function useDownMd(): boolean {
    const [isBelowMd, setIsBelowMd] = useState(window.matchMedia('(max-width: 767px)').matches);

    useEffect(() => {
        const handleResize = () => {
            setIsBelowMd(window.matchMedia('(max-width: 767px)').matches);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return isBelowMd;
}